/* eslint-disable import/no-cycle */
import { configureStore } from '@reduxjs/toolkit';
import { PersistConfig, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from '../reducers';

const persistConfig: PersistConfig<any> = {
  key: 'root',
  storage,
  version: 1,
  migrate: (state, currentVersion) =>
    Promise.resolve(
      state?._persist.version !== currentVersion
        ? {
            _persist: {
              version: currentVersion,
              rehydrated: true,
            },
          }
        : state
    ),
  blacklist: [
    'otp',
    'address',
    'order',
    'vendor',
    'discountCode',
    'users',
    'category',
    'menuItem',
    'availabilityTimes',
    'reports',
    'userTransaction',
    'vendorInformation',
    'foodShifts',
    'printers',
    'printerStation',
    'defaultDescriptions',
    'reportHourly',
    'offlineOrdering',
    'offlineAddress',
    'discount',
    'bank',
    'vendorAvailability',
    'updateOrder',
    'ordersList',
    'batchBikers',
    'callerIdSlice',
    'ordering',
    'posTerminal',
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export { persistor, store };

export {};

declare global {
  interface Window {
    store?: import('@reduxjs/toolkit').EnhancedStore; // Adjust the type according to your store
  }
}

if (typeof window !== 'undefined' && window.Cypress) {
  window.store = store;
}
